// @ts-nocheck
import isApiError from "@insite/client-framework/Common/isApiError";
import { rawRequest, ServiceResult } from "@insite/client-framework/Services/ApiService";

const signUpUrl = "/api/v1/custom/account/signup";

export async function submitAccountSignUp(
    emailAddress: string,
): Promise<ServiceResult<{ status: number; emailStatus: string }>> {
    try {
        const response = await rawRequest(`${signUpUrl}/${encodeURIComponent(emailAddress)}`, "POST");

        if (response.status === 204) {
            return {
                successful: true,
                result: { status: response.status, emailStatus: "" },
            };
        }

        return {
            successful: true,
            result: {
                status: response.status,
                emailStatus: (await response.json()).emailStatus,
            },
        };
    } catch (error) {
        if (isApiError(error)) {
            return {
                successful: false,
                errorMessage: error.errorJson?.message || error.errorMessage || "",
                statusCode: error.status,
            };
        }

        throw error;
    }
}
